import { View } from 'react-native';

import { Skeleton } from '@/components/ui/Skeleton';
import { Surface } from '@/components/ui/Surface';

/** Loading placeholder matching {@link TemplateRow}'s shape. */
export function TemplateRowSkeleton() {
  return (
    <Surface className="overflow-hidden">
      <View className="flex-row items-center gap-3 px-4 py-3.5">
        <Skeleton className="h-11 w-11 rounded-xl" />
        <View className="flex-1">
          <Skeleton className="h-4 w-2/5 rounded-md" />
          <Skeleton className="mt-1.5 h-3 w-1/4 rounded-md" />
        </View>
      </View>
    </Surface>
  );
}
